<template>
    <span> <slot name="activator" v-bind="{ active, toggle }" /> </span>
</template>

<script>
import api from "@/api";
import { mapActions, mapMutations } from "vuex";

export default {
    props: {
        params: { type: Object, default: () => ({}) },
    },
    computed: {
        likes() {
            return this.$store.state.likes;
        },
        like() {
            return (this.likes || []).find((item) => !Object.keys(this.params).some((key) => item[key] != this.params[key]));
        },
        active() {
            return !!this.like;
        },
    },
    mounted() {
        this.init();
    },
    watch: {
        _recruitment() {
            this.init();
        },
    },
    methods: {
        ...mapActions(["getLikes"]),
        ...mapMutations(["setLikes"]),
        async init() {
            if (this.$store.state.payload?._user && !this.likes) await this.getLikes();
        },
        async toggle() {
            if (!this.$store.state.payload?._user) return;
            if (!!this.like) {
                await api.v1.me.likes.delete({ _id: this.like._id });
                this.setLikes({ likes: (this.likes || []).filter(({ _id }) => _id !== this.like._id) });
                this.$emit("removed");
            } else {
                const { like } = await api.v1.me.likes.post(this.params);
                this.setLikes({ likes: [...(this.likes || []), like] });
            }
        },
    },
};
</script>

<style></style>
